import { Component, inject, signal } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { LOCATION_FLAG_REASONS } from '../../../../constants';
import { NotifyService } from '../../../../service/notify.service';
import { SubscriptionService } from '../../../../service/subscription.service';
import { LocationResponse, LocationFlagReason } from '../../../../types';

type CellParams = ICellRendererParams<LocationResponse> & {
  mergeCallback: (item: LocationResponse) => void;
  transferCallback: (item: LocationResponse) => void;
  archiveCallback: (item: LocationResponse) => void;
  editCallback: (item: LocationResponse) => void;
  refreshCallback: () => void;
};

@Component({
  selector: 'app-pan-cell-locations-list-actions',
  imports: [UiModule, MatTooltipModule, RouterModule, MatMenuModule, SweetAlert2Module],
  templateUrl: './cell-locations-list-actions.component.html',
  styleUrl: './cell-locations-list-actions.component.scss',
})
export class CellLocationsListActionsComponent implements ICellRendererAngularComp {
  private subscriptionService = inject(SubscriptionService);
  private notifyService = inject(NotifyService);

  public params!: CellParams;

  public readonly errorReasonCodes: LocationFlagReason[] = LOCATION_FLAG_REASONS;
  public chosenErrorCodes = signal<string[]>([]);

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }

  updateCodes() {
    this.chosenErrorCodes.set(this.params.data.flagged_reasons ?? []);
  }

  updateSelection(value: string, checkedTarget: EventTarget) {
    const checked = (checkedTarget as HTMLInputElement).checked;
    let reasons = this.chosenErrorCodes();

    if (checked) {
      reasons.push(value);
    } else {
      reasons = reasons.filter((reason) => reason !== value);
    }

    this.chosenErrorCodes.set(reasons);
  }

  saveErrorFlags() {
    // this prevents the "unflaggable" location problem by making sure that only supported reasons are in the array
    const supportedReasons = this.chosenErrorCodes().filter((reason) => this.errorReasonCodes.find((code) => code.id === reason));

    this.subscriptionService.toggleFlagLocation(this.params.data.id, supportedReasons).subscribe({
      error: () => {
        this.notifyService.notify('Toggle flags failed.');
      },
      next: () => {
        this.notifyService.notify('Updated flags for this location!');
        this.params.data.flagged_reasons = supportedReasons;
      },
    });
  }
}
